import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto, Alert } from "../../../js/ComponentManager";
import { OrderType } from '../../MyPage/Basket/OrderType';
/* 개발담당:양유빈
 * 화면기능: 채팅상태에서 주문하기
 * 세부설명:
*/

export class ChatOrder extends Component {
    static displayName = ChatOrder.name;

    constructor(props) {
        super(props);
        this.state = {
            OrderHeader: [],
            OrdGoodList: [],
            OrdOrginData: [],
            Content:"",
            isOk: false
        };
        this.OrderTypeRef = React.createRef(); 

        this.CsName = Big3Common.ContentState;
        this.Uid = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Uid, "");
        this.Qstgrp_No = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.QstgrpNo, "");
        this.Qst_Status = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.QstStatus, "");

        this.handleCancel_Click = this.handleCancel_Click.bind(this);
        this.handleCheck_Click = this.handleCheck_Click.bind(this);
        this.CallBackOrderType = this.CallBackOrderType.bind(this);
        this.handleBuy_Click = this.handleBuy_Click.bind(this);
        this.handleQuan_Change = this.handleQuan_Change.bind(this);
    }
    //초기화
    async componentDidMount() {
        
        await this.CallQstMgtGoodsListData();
    }
    //주문설정 후 Callback 함수실행 --> ConverInfo로 이동(원래 값설정)
    async CallBackOrderType() {        
        const whole_name = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Whole_Name, "");
        const LastStatus = Big3Common.Util.GetContentState(this.props.ContentState, "LastStatus", "");
        this.props.RenderComponent("ConverInfo",
        {
            [this.CsName.Uid]: this.Uid,
            [this.CsName.QstgrpNo]: this.QstgrpNo,
            [this.CsName.QstStatus]: this.Qst_Status,
            [this.CsName.Whole_Name]: whole_name,
            "LastStatus": LastStatus
        });
        
        return false;
    }
    //데이터 조회
    async CallQstMgtGoodsListData() {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Chat/Answer/GetQstMgtGoodsList',
                {
                    Uid: this.Uid,
                    Qstgrp_No: this.Qstgrp_No,
                    Qst_Status: this.Qst_Status
                }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const OrderHeader = DataList.OrderHeader;
                const OrderDtl = DataList.OrderDtl;
                const OrdOrginData = DataList.OrderDtl;
                //selected 속성 추가, soldout_yn은 상품 등록시 구매불가 설정, buy_yn은 질문의 구매불가 설정임. 
                OrderDtl.map(list => {
                    if (list.soldout_yn === "Y" || list.buy_yn==="N") {
                        //솔드아웃일 경우 구매 불가
                        list.selected = "N"; 
                    }
                    else { 
                        list.selected = "Y";
                    }
                    return false;
                }); 
                const GoodsList = Big3Common.Util.groupBy(OrderDtl, list => list.goods_no);
                const OrdDtListJson = [];
               
                for (const item of GoodsList.entries()) {
                    //사진 헤더에 selected 속성 추가하는데 하위 노드에  selected="N"이 한개라도 있으면 "N"
                    let SelectYn = item[1].filter(list => list.selected === "N").length;
                    OrdDtListJson.push({
                        "GoodsList": { GoodsNo: item[0], selected: SelectYn >0 ? "N" : "Y" },
                        "OrderList": item[1]
                    });
                }
                this.setState({ OrderHeader: OrderHeader, OrdGoodList: OrdDtListJson, OrdOrginData: OrdOrginData });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstMgtGoodsListData", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //취소
    handleCancel_Click(event) {

        const whole_name = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Whole_Name, "");
        const LastStatus = Big3Common.Util.GetContentState(this.props.ContentState, "LastStatus", "");
        this.props.RenderComponent("Inventory",
            {
                [this.CsName.Uid]: this.Uid,
                [this.CsName.QstgrpNo]: this.Qstgrp_No,
                [this.CsName.QstStatus]: this.Qst_Status,
                [this.CsName.Whole_Name]: whole_name,
                LastStatus: LastStatus
            });
        event.preventDefault();
    }
    //체크박스 선택
    handleCheck_Click(event, list) {
        let selected = event.target.checked === true ? "Y" : "N";
        if (list === undefined) {
            //전체선택
            //soldout_yn이 아니고, 구매 가능한 상품만 체크
            this.state.OrdGoodList.map(x => {                
                x.OrderList.map(z => {
                    if (z.soldout_yn === "N" && z.buy_yn === "Y") {
                        x.GoodsList.selected = selected;
                        z.selected = selected;
                    }
                    return false;
                });
                return false;
            });
        }
        else {
            if (list.quan === undefined) {
                //상품 마스터 선택
                this.state.OrdGoodList.map(x => {
                    x.OrderList.filter(filter => filter.goods_no === list.GoodsNo).map(z => {
                        if (z.soldout_yn === "N" && z.buy_yn === "Y") {
                            x.GoodsList.selected = selected;
                            z.selected = selected;
                        }
                        return false;
                    });
                    return false;
                });
            }
            else {
                //개별상품 선택
                this.state.OrdGoodList.map(x => {
                    x.OrderList.filter(filter => filter.qstmgt_seq === list.qstmgt_seq).map(z => {
                        if (z.soldout_yn === "N" && z.buy_yn === "Y") {
                            z.selected = selected;
                        }
                        //개별상품이 하나이상 또는 없을 경우 상품 마스터 선택 변경
                        let selectCnt = x.OrderList.filter(y => y.goods_no === z.goods_no && y.selected === "Y").length;
                        x.GoodsList.selected = selectCnt === 0 ? "N" : "Y";
                        return false;
                    });
                    return false;
                });
            }
        }
        this.setState({ isOk: true });
        return false;
    }
    handleBuy_Click(event) {

        let Model = [];
        this.state.OrdGoodList.map(x => {
            return x.OrderList.map(z => {
                if (z.selected === "Y") {
                    Model.push({
                        uid: z.uid,
                        goods_no: z.goods_no,
                        crd_cd: z.crd_cd,
                        sizgrp_cd: z.sizgrp_cd,
                        siz_cd: z.siz_cd,
                        quan: z.quan,
                        goods_price: z.goods_price,
                        qstgrp_no: this.Qstgrp_No,
                        qst_status: "JM"
                    });
                }
                return false;
            });
        });
        
        if (Model.length === 0) {
            this.setState({ Content: "구매할 상품을 선택하여 주세요." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }

        const QuanCount = this.state.OrdGoodList[0].OrderList.filter(list => list.quan === null || list.quan === "" || list.quan === 0);

        if (QuanCount.length > 0) {
            this.setState({ Content: "구매수량을 확인해 주세요." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
       
        this.OrderTypeRef.current.GoodsParameterSet(Model);
        Big3Common.ModalAlert(bootstrap, "OrderType");
        event.preventDefault();
    }
      
    handleQuan_Change(event, list, plus) {
        const Type = event.target.type;
        let Value = 0;
        let Quan = list.quan;
        const MaxQuan = list.maxquan;
        const Sinsale_yn = list.sinsale_yn;
        const Sinsale_Count = Big3Common.WebConfig.Sinsale_Count;
        let Totalprice = 0;
        if (list.soldout_yn === "Y" || list.buy_yn === "N") {
            //soldout 이거나, 구매 불가 항목은 경고
            this.setState({ Content: "품절 상품은 변경할 수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Quan === 1 && plus < 0) {

            this.setState({ Content: "구매수량은 1보다 작을수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Quan > 999) {
            this.setState({ Content: "구매수량은 1000보다 클수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (MaxQuan === Quan && plus > 0) {
            this.setState({ Content: `최대 구매수량은 ${MaxQuan}개 입니다.` });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Sinsale_yn === "N" && Quan === Sinsale_Count && plus < 0) {
            this.setState({ Content: `낱장 구매는 할수 없습니다.` });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Type === "text") {
            Value = event.target.value;
            if (Big3Common.Util.isNumber(Value) === false) {
                return false;
            }
            Quan = Value === "" ? 0 : parseInt(Value);
            
            if (MaxQuan < Quan) {
                this.setState({ Content: `최대 구매수량은 ${MaxQuan}개 입니다.` });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }
            if (Sinsale_yn === "N" && Quan === Sinsale_Count) {
                this.setState({ Content: `낱장 구매는 할수 없습니다.` });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }
        }
        else {
            Quan = Quan + (parseInt(plus));
        }
        Totalprice = (Quan === "" ? 0 : Quan * list.goods_price);
        list.quan = Quan;
        list.goods_price_sum = Totalprice;
        this.setState({ isOk: true });
        event.preventDefault();
        
    }
    //헤더정보
    Headerrender() {
        if (this.state.OrderHeader.length === 0) {
            return false;
        }
        const OrderHeader = this.state.OrderHeader[0];
        return (
            <div className="order_shop_info_box order_shop_info_box_v3">
                <div className="shop_info">
                    <div className="shop_name">{OrderHeader.whole_name}</div>
                    <div className="shop_info_icon1" onClick={(e) => { this.props.RenderComponent('WhQuestList', this.props.ContentState); e.preventDefault(); }}></div>
                    <div className="shop_info_icon2" onClick={() => { window.location.href = `tel:${OrderHeader.whole_phone}` }}></div>
                </div>
                <div className="order_number">문의번호 : {this.Qstgrp_No} </div>
                <div className="shop_address">상가주소 ({OrderHeader.bld_name} {OrderHeader.flr_name}층 {OrderHeader.whole_no_name}호)</div>
            </div>
        )
    }
    //상품 서브리스트
    Goodssubrender(OrderList, soldout_yn) {
        return (
            <div>
                {OrderList.map((list, idx) => 
                    <div className="product_order" key={idx}>
                        <div className="product_choice">
                            <input className={list.buy_yn === "Y" && soldout_yn ==="N" ? "form-check-input" : "item_hide" }
                                checked={list.selected === "Y" ? true : false}
                                onChange={(e) => { this.handleCheck_Click(e, list) }}
                                type="checkbox"
                            />
                        </div>
                        <div className="product_order_info">
                            <div className={list.buy_yn === "Y" ? "product_name" :" product_name point"}>{list.crd_cd_nm} / {list.size_nm}{list.buy_yn==="Y" ? "":"(품절)" }</div>
                            <div className="product_order_data">
                                <div className="number_check">
                                    <button type="button" onClick={(e) => { this.handleQuan_Change(e, list, -1) }}>-</button>
                                    <input type="text" className="form-control"
                                        value={list.quan}
                                        maxLength="3"
                                        onChange={(e) => { this.handleQuan_Change(e, list, 0) }}
                                      />
                                    <button type="button" className="btn_2" onClick={(e) => { this.handleQuan_Change(e, list, 1) }}>+</button>
                                </div>
                                <div className="product_price  padding_no">{Big3Common.Util.Money(list.goods_price_sum)}</div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="total_amount total_amount2">
                    <div className="total total_1">합 계</div>
                    <div className="total">{OrderList.reduce((acc, item) => { if (item.selected === "Y") { return acc + item.quan } return acc; }, 0)}</div>
                    <div className="amount padding_no">{Big3Common.Util.Money(OrderList.reduce((acc, item) => { if (item.selected === "Y") { return acc + item.goods_price_sum } return acc; }, 0))}원</div>
                </div>
            </div>
        )
    }
    //상품 마스터
    Goodsrender() {
              
        const OrdGoodList = this.state.OrdGoodList;
        if (OrdGoodList.length === 0) return false;
        const OrdOrginData = this.state.OrdOrginData;
        return (
            <>
                {
                    OrdGoodList.map((list, idx) =>
                        <div className="basket_box basket_box_v2" key={idx}>
                            <div className="product_box">
                                <div className="product_choice">
                                    <input className={list.OrderList[0].soldout_yn === "N" ? "form-check-input" : "item_hide"}
                                        type="checkbox"
                                        checked={list.GoodsList.selected === "Y" ? true : false}
                                        onChange={(e) => { this.handleCheck_Click(e, list.GoodsList) }}
                                    />
                                </div>
                                <div className="product_detail">
                                    <div className="product_img_box">
                                        <GoodsPhoto
                                            className="product_img"
                                            ImageSrc={list.OrderList[0].img_220}
                                            SoldoutYn={list.OrderList[0].soldout_yn}
                                        />
                                    </div>
                                    <div className="product_info">
                                        <div className="product_name">{list.OrderList[0].goods_nm}</div>
                                        <div className="product_state">{list.OrderList[0].sinsale_yn === "Y" ? "낱장가능" : "낱장불가"}</div>
                                        <div className="product_price  padding_no">{Big3Common.Util.Money(list.OrderList[0].goods_price)}원</div>
                                    </div>
                                </div>
                            </div>
                            {this.Goodssubrender(list.OrderList, list.OrderList[0].soldout_yn)}
                        </div>
                    )
                }
                <div className="table_box sum_table margin_top ">
                    <table className="table td_left">
                        <colgroup>
                            <col width="33.33%" />
                            <col width="33.33%" />
                            <col width="33.33%" />
                        </colgroup>
                        <tbody>
                        </tbody>
                        <tbody>
                            <tr>
                                <td>총 합계</td>
                                <td>{OrdOrginData.reduce((acc, item) => { if (item.selected === "Y") { return acc + item.quan } return acc; }, 0)}</td>
                                <td>{Big3Common.Util.Money(OrdOrginData.reduce((acc, item) => { if (item.selected === "Y") { return acc + item.goods_price_sum } return acc; }, 0))}원</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </>
        )
    }
    render() {
        const Headerrender = this.Headerrender();
        const Goodsrender = this.Goodsrender();
        return (
            <div>
                <div className="container_box u_padding p_b_margin">
                    {Headerrender }
                    <div className="all_box all_box_v2">
                        <div className="all_choise">
                            <input className="form-check-input"
                                type="checkbox"
                                onChange={(e) => { this.handleCheck_Click(e) }}
                            />
                            <label className="form-check-label">
                                전체선택
                            </label>
                        </div>
                    </div>
                    {Goodsrender}
                    <div className="button_line  f_bottom f_n_bottom">
                        <button type="button" className="btn_s btn_inactive" onClick={this.handleCancel_Click}>주문취소</button>
                        <button type="button" className="btn_s btn_v1" onClick={(e) => { this.handleBuy_Click(e); }}>주문확인</button>
                    </div>
                </div> 
                <OrderType id="OrderType"
                    ref={this.OrderTypeRef}
                />
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="주문안내"
                />
            </div>
        );
    }
}
